export default function ($el) {
  $el.on('click', () => {
    YT.get($el.data('yt-player-id')).playVideo();
    $el.addClass('video-active');
  });
}
